import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Slide from "@material-ui/core/Slide";
import VideoPlayer from "./videoPlayer";
import { DialogTitle } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import "../index.scss";
import YoutubeIcon from "../icons/Youtube.svg";

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: "relative",
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  dialogTitleContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(2),
  },

  dialogTitle: {
    fontFamily: "Inter",
    fontSize: "16px",
    fontWeight: "400",
    color: "#E2136E",
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function VideoModal({ video_link }) {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div className="video-modal-container">
      <button onClick={handleClickOpen}>
        <img src={YoutubeIcon} />
        আবার দেখে নিন
      </button>
      <Dialog
        fullScreen
        open={open}
        onClose={handleClose}
        TransitionComponent={Transition}
      >
        <div className={classes.dialogTitleContainer}>
          <p className={classes.dialogTitle}>ভিডিওটি আবার দেখে নিন</p>
          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={handleClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <VideoPlayer
          data={{ video_link: video_link }}
          isShort={true}
          callBack={handleClose}
          mode="modal"
        />
      </Dialog>
    </div>
  );
}
